import React from "react"
import SideBarLayout from "../../layout/side-bar-layout"
import {Grid} from "@mui/material"
import InfoCard from "../../components/InfoCard/info-card"
import SmartButtonRoundedIcon from '@mui/icons-material/SmartButtonRounded'
import TableChartRoundedIcon from '@mui/icons-material/TableChartRounded'
import TextFieldsRoundedIcon from '@mui/icons-material/TextFieldsRounded'
import ViewSidebarRoundedIcon from '@mui/icons-material/ViewSidebarRounded'
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'
import ViewStreamRoundedIcon from '@mui/icons-material/ViewStreamRounded'
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded'
import WorkspacePremiumRoundedIcon from '@mui/icons-material/WorkspacePremiumRounded'
import DynamicFormRoundedIcon from "@mui/icons-material/DynamicFormRounded"
import GridOnRoundedIcon from "@mui/icons-material/GridOnRounded"
import {TITLE_DESIGN_SYSTEM_PAGE} from "../../../utils/constants"
import {
    DESIGN_SYSTEM_BUTTON_PAGE,
    DESIGN_SYSTEM_INPUT_PAGE, DESIGN_SYSTEM_SIDEBAR_PAGE, DESIGN_SYSTEM_SNACKBAR_PAGE,
    DESIGN_SYSTEM_TABLE_PAGE, DESIGN_SYSTEM_DUPLA_CONFIRMACAO_PAGE, DESIGN_SYSTEM_FORM_SECTION_PAGE,
    DESIGN_SYSTEM_STATUS_BADGE_PAGE, DESIGN_SYSTEM_FIELD_RENDERER_PAGE, DESIGN_SYSTEM_GRID_FORM_SHEET_PAGE, DESIGN_SYSTEM_MODAL_DUPLICAR_PAGE
} from "../../../utils/routes"
import {useNavigate} from "react-router-dom"

const DesignSystemPage = () => {
    const navigate = useNavigate()
    const components = [
        {type: "Buttons", icon: <SmartButtonRoundedIcon/>, route: DESIGN_SYSTEM_BUTTON_PAGE},
        {type: "Table", icon: <TableChartRoundedIcon/>, route: DESIGN_SYSTEM_TABLE_PAGE},
        {type: "Inputs", icon: <TextFieldsRoundedIcon/>, route: DESIGN_SYSTEM_INPUT_PAGE},
        {type: "Sidebar", icon: <ViewSidebarRoundedIcon/>, route: DESIGN_SYSTEM_SIDEBAR_PAGE},
        {type: "Dupla Confirmação", icon: <WarningAmberRoundedIcon/>, route: DESIGN_SYSTEM_DUPLA_CONFIRMACAO_PAGE},
        {type: "Modal Duplicar", icon: <WarningAmberRoundedIcon/>, route: DESIGN_SYSTEM_MODAL_DUPLICAR_PAGE},
        {type: "Form Sections", icon: <FactCheckRoundedIcon/>, route: DESIGN_SYSTEM_FORM_SECTION_PAGE},
        {type: "Status Badge", icon: <WorkspacePremiumRoundedIcon/>, route: DESIGN_SYSTEM_STATUS_BADGE_PAGE},
        {type: "Snackbar", icon: <ViewStreamRoundedIcon/>, route: DESIGN_SYSTEM_SNACKBAR_PAGE},
        {type: "Field Renderer", icon: <DynamicFormRoundedIcon/>, route: DESIGN_SYSTEM_FIELD_RENDERER_PAGE},
        {type: "Grid Form Sheet", icon: <GridOnRoundedIcon/>, route: DESIGN_SYSTEM_GRID_FORM_SHEET_PAGE},
    ]

    return (
        <SideBarLayout
            header
            title={TITLE_DESIGN_SYSTEM_PAGE}
            headerTitle={TITLE_DESIGN_SYSTEM_PAGE}>

            <Grid
                container
                spacing={4}
                sx={{
                    px: {xs: 2, sm: 4, md: 10, lg: 14},
                    mt: {xs: 4, sm: 6, md: 10, lg: 12},
                }}
            >
                {components.map((component, index) => (
                    <Grid
                        key={`component-${index}`}
                        item xs={12} md={3} xl={2}
                    >
                        <InfoCard
                            icon={component.icon}
                            height={200}
                            label={component.type}
                            onClick={() => navigate(component.route)}
                        />
                    </Grid>
                ))}
            </Grid>
        </SideBarLayout>
    )
}

export default DesignSystemPage
